import TEMPLATE_URL from 'emun.salesrep/territory-manager/division/parser/division-parser.htm'
import controller from 'emun.salesrep/territory-manager/division/parser/division-parser.controller'
import modals from 'webmodals/modals'

const NOOP = () => { };

export default ({
    size = 'md',
    backdrop = 'static',
    templateUrl = TEMPLATE_URL,
    title = 'Division Bulk Pad...',
    subTitle = 'Enter Division IDs separated by comma or white-space',
    view = 'cards',
    selected = {},
    onToggle = NOOP,
    onDivisionSelected = NOOP,
    onDivisionDeselected = NOOP,
} = {}) => modals.open({
        size,
        backdrop,
        templateUrl,
        controller,
        bindToController: true,
        controllerAs: '$ctrl',
        resolve: {
            options: () => ({
                title,
                subTitle,
                onDivisionSelected,
                onDivisionDeselected,
                view,
            })
        }
    }).result;